export const VERSION = '2.49.1';
